import React from 'react';

const LinkedInIcon = ({ 
  size = 36, 
  color = "#4A9EDB", 
  className = "" 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 36 36" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="LinkedIn"
      role="img"
    >
      <path 
        d="M32 0C33.0609 0 34.0783 0.421427 34.8284 1.17157C35.5786 1.92172 36 2.93913 36 4V32C36 33.0609 35.5786 34.0783 34.8284 34.8284C34.0783 35.5786 33.0609 36 32 36H4C2.93913 36 1.92172 35.5786 1.17157 34.8284C0.421427 34.0783 0 33.0609 0 32V4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0H32ZM31 31V20.4C31 18.6708 30.3131 17.0124 29.0903 15.7897C27.8676 14.5669 26.2092 13.88 24.48 13.88C22.78 13.88 20.8 14.92 19.84 16.48V14.26H14.26V31H19.84V21.14C19.84 19.6 21.08 18.34 22.62 18.34C23.3626 18.34 24.0748 18.635 24.5999 19.1601C25.125 19.6852 25.42 20.3974 25.42 21.14V31H31ZM7.76 11.12C8.65113 11.12 9.50576 10.766 10.1359 10.1359C10.766 9.50576 11.12 8.65113 11.12 7.76C11.12 5.9 9.62 4.38 7.76 4.38C6.86357 4.38 6.00385 4.73611 5.36998 5.36998C4.73611 6.00385 4.38 6.86357 4.38 7.76C4.38 9.62 5.9 11.12 7.76 11.12ZM10.54 31V14.26H5V31H10.54Z" 
        fill={color} 
      />
    </svg>
  );
};

export default LinkedInIcon;